import React, { ReactElement, useState, useRef } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { QRCodeSVG } from 'qrcode.react';
import { downloadQRCode } from 'utils/worksheet/downloadQRCode';
import { CloseIcon } from 'assets/icons/v2';
import { CustomModal } from 'components/common/Modal/CustomModal';
import { CustomModalContent } from 'components/common/Modal/CustomModalContent';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import { QRActionButtons } from './components/QRActionButtons';

type Props = {
  isOpen: boolean;
  worksheetId: string;
  worksheetTitle: string;
  worksheetUrl: string;
  offsetLeft?: string;
  onClose: () => void;
};

export const QRShareModal = ({
  isOpen,
  worksheetId,
  worksheetTitle,
  worksheetUrl,
  offsetLeft,
  onClose,
}: Props): ReactElement => {
  const [hasCopied, setHasCopied] = useState(false);
  const qrCodeRef = useRef<SVGSVGElement>(null);

  const handleDownloadQR = (): void => {
    downloadQRCode(qrCodeRef, `novaheal-worksheet-${worksheetId}-qr-code`);
  };

  const handleCopyLink = (): void => {
    navigator.clipboard.writeText(worksheetUrl);
    setHasCopied(true);
    setTimeout(() => setHasCopied(false), 2000);
  };

  return (
    <CustomModal isOpen={isOpen} onClose={onClose} placement="center" hideHeader size="md">
      <CustomModalContent p={{ base: '30px' }}>
        <NovaIconButton
          aria-label="Schließen"
          variant="primary"
          size="l"
          onClick={onClose}
          icon={CloseIcon}
          iconProps={{ color: 'text.secondary' }}
          position="absolute"
          right="0"
          top="0"
        />
        <Text textStyle="h4.medium" color="text.primary" textAlign="center" mb="l">
          Teile &quot;{worksheetTitle || 'Arbeitsblatt'}&quot;
        </Text>

        <Flex direction="column" align="center" gap="30px" width="100%">
          <Box>
            <QRCodeSVG ref={qrCodeRef} value={worksheetUrl} size={265} level="H" />
          </Box>

          <QRActionButtons
            onDownload={handleDownloadQR}
            onCopy={handleCopyLink}
            hasCopied={hasCopied}
          />
        </Flex>
      </CustomModalContent>
    </CustomModal>
  );
};
